'use client';
import { isConvertibleColor } from '../../../modules/colors/impl/validators/validators.js';
import { toRGBA } from '../../../modules/colors/impl/toRGBA/toRGBA.js';

/**
 * Эмпирически полученное пороговое значение
 * гамма-скорректированного напряжения яркости
 * при котором цветовые вариации выводятся корректно.
 * */ const Y_THRESHOLD = 204;
const foreground = (raw, threshold = Y_THRESHOLD)=>{
    if (!isConvertibleColor(raw)) {
        return 'none';
    }
    const { r, g, b } = toRGBA(raw);
    /** https://ru.wikipedia.org/wiki/YIQ
     * Y - гамма-скорректированное напряжение яркости
     * */ const y = (r * 299 + g * 587 + b * 114) / 1000;
    return y >= threshold ? 'dark' : 'light';
};

export { Y_THRESHOLD, foreground };
//# sourceMappingURL=foreground.js.map
